//接口文档http://43.138.218.52:8090/swagger-ui.html#/


//  https://hzshixiang.site/aromaAdmin/index.html#/Login



// token=>202过期默认账号密码admin 123456
// Csj12321品牌

const urls = "https://hzshixiang.site/";
// const urls = "http://139.186.247.74/";

const mubanId = 12192;

const https = "https://hzshixiang.site/pc/";
// const https = "http://139.186.247.74:8090/pc/";

const api = {

	uploadImg: "https://hzshixiang.site/pc/file/upload",//图片上传

	uploadImgV2: "https://hzshixiang.site/pc/file/uploadV2",//图片上传V2

	Login: https + "manager/login",//登录



	// 文件上传
	uploadFile: https + "file/uploa",//上传


	// 账号
	addAccount: https + "manager/add",//新增
	delAccount: https + "manager/delete",//删除
	selAccount: https + "manager/getList",//查询
	upAccount: https + "manager/update",//更新


	// 品牌管理
	addBrand: https + "brand/add",//新增
	delBrand: https + "brand/delete",//删除
	selBrand: https + "brand/getList",//查询
	upBrand: https + "brand/update",//更新


	// 品牌型号
	addModel: https + "type/add",//新增
	delModel: https + "type/delete",//删除
	selModel: https + "type/getList",//查询
	upModel: https + "type/update",//更新


	//用户管理
	addUser: https + "user/add",//新增
	delUser: https + "user/delete",//删除
	selUser: https + "user/getList",//查询
	upUser: https + "user/update",//更新

	//基本设置
	addSet: https + "set/add",//新增
	delSet: https + "set/delete",//删除
	selSet: https + "set/getList",//查询
	upSet: https + "set/update",//更新



	//反馈意见
	addFeedback: https + "opinion/add",//新增
	delFeedback: https + "opinion/delete",//删除
	selFeedback: https + "opinion/getList",//查询
	upFeedback: https + "opinion/update",//更新



	//常见问题
	addQuestion: https + "question/add",//新增
	delQuestion: https + "question/delete",//删除
	selQuestion: https + "question/getList",//查询
	upQuestion: https + "question/update",//更新

	//轮播图
	addBanner: https + "slideshow/add",//新增
	delBanner: https + "slideshow/delete",//删除
	selBanner: https + "slideshow/getList",//查询
	upBanner: https + "slideshow/update",//更新



	//物流公司
	addLogistics: https + "company/add",//新增
	delLogistics: https + "company/delete",//删除
	selLogistics: https + "company/getList",//查询
	upLogistics: https + "company/update",//更新




	// 轮播图
	addBanner: https + "slideshow/add",//新增
	delBanner: https + "slideshow/delete",//删除
	selBanner: https + "slideshow/getList",//查询
	upBanner: https + "slideshow/update",//更新

	// 设置相关
	addSet: https + "set/add",//新增
	delSet: https + "set/delete",//删除
	selSet: https + "set/getList",//查询
	upSet: https + "set/update",//更新

	// 类别
	addType: https + "type/add",//新增
	delType: https + "type/delete",//删除
	selType: https + "type/getList",//查询
	upType: https + "type/update",//更新



	// 订单
	addOrder: https + "order/add",//新增
	delOrder: https + "order/delete",//删除
	selOrder: https + "order/getList",//查询
	upOrder: https + "order/update",//更新
	refundOrder: https + "payReturn/return",//退款
	refundFatherpayOrder: https + "fatherpayReturn//return",//父级退款

	addReservation: https + "sf/addOrder2",//预约

	// 导出
	excelOrder: https + "excel/addOrderExcel",//导出

	jsOrderExcel: https + "excel/jsOrderExcel",//导出


	//用户
	addUser: https + "user/add",//新增
	delUser: https + "user/delete",//删除
	selUser: https + "user/getList",//查询
	upUser: https + "user/update",//更新


	
	//金额设置
	addCharge: https + "charge/add",//新增
	delCharge: https + "charge/delete",//删除
	selCharge: https + "charge/getList",//查询
	upCharge: https + "charge/update",//更新


	// 鉴别编号
	identifyCode:https + "jbdh/getJbdh",//查询

	// 短信通知
	sendReportNotify: https + "order/sendReportNotify",//发送报告通知短信

	// 批号查询管理
	selBatchCalLogic: https + "batchCalLogic/page",//品牌逻辑列表查询
	saveBrandBatchCalLogic: https + "brandBatchCalLogic/save",//关联品牌
	updateBatchCalLogic: https + "batchCalLogic/update",//更新品牌逻辑
	getBrandsByCode: https + "batchCalLogic/getBrandsByCode/",//根据逻辑编码查询关联品牌
	getLogicsByBrandId: https + "batchCalLogic/getLogicsByBrandId/",//根据品牌ID查询关联逻辑
	removeBrandBatchCalLogic: https + "brandBatchCalLogic/remove/",//删除关联品牌
	selUserContributionBatch: https + "userContributionBatch/page",//用户贡献批号列表查询
	updateUserContributionBatch: https + "userContributionBatch/update",//更新贡献批号
	removeUserContributionBatch: https + "userContributionBatch/remove/",//删除贡献批号
	selUserNoBrandBatchCalLogic: https + "userNoBrandBatchCalLogic/page",//无品牌逻辑查询记录

	// 型号搜索无结果（用户搜不到的关键词记录）
	selTypeSearchMiss: https + "typeSearchMiss/getList",//分页查询
	upTypeSearchMissStatus: https + "typeSearchMiss/updateStatus",//更新状态/备注

}

module.exports = {
	api: api,
	urls: urls,
	mubanId: mubanId,
}


// WEBPACK FOOTER //
// ./src/util/requestUrl.js